import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SentenceElementHensynsled = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5,
    strokeWidth: "8",
    children: /*#__PURE__*/jsx("path", {
      d: "M7 7h85v85H7z"
    })
  });
};

export { SentenceElementHensynsled };
//# sourceMappingURL=sentence-element.hensynsled.js.map
